/* eslint-disable @typescript-eslint/no-explicit-any */
export const generateRangeLabels = (
	boundaryRanges: number[],
	reverse?: boolean,
): string[] => {
	const rangeLabels: string[] = [];

	if (boundaryRanges.length === 0) {
		return [];
	}

	for (const range of boundaryRanges) {
		const temp = range.toFixed(2);
		rangeLabels.push(temp);
	}

	if (!reverse) return rangeLabels;
	else return rangeLabels.reverse();
};

export const legendsColors = {
	negligible: 'rgb(0, 124, 160)',
	low: 'rgb(74, 126, 4)',
	medium: 'rgb(239, 179, 4)',
	high: 'rgb(255, 122, 0)',
	extreme: 'rgb(170, 0, 0)',
};

export const legends = [
	{ name: 'negligible', color: legendsColors.negligible },
	{ name: 'low', color: legendsColors.low },
	{ name: 'medium', color: legendsColors.medium },
	{ name: 'high', color: legendsColors.high },
	{ name: 'extreme', color: legendsColors.extreme },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSortedGridData = (data: any) => {
	const tempDataCopy = [...data];

	const gridData: any = [];
	//get numbered positions
	tempDataCopy.forEach(obj => {
		const concatd = `${obj.position.x}${obj.position.y}`;
		gridData.push({ ...obj, calculatedPosition: Number(concatd) });
	});
	gridData.sort((a: any, b: any) => {
		if (a.position.y !== b.position.y) {
			return b.position.y - a.position.y; // Sort by y in descending order
		}
		return a.position.x - b.position.x; // Sort by x in ascending order
	});

	//create array of arrays to separate rows
	const newGridData = [];
	for (let i = 0; i < gridData.length; i += 5) {
		const row = [];
		for (let j = i; j < i + 5; j++) {
			delete gridData[j].calculatedPosition;
			row.push(gridData[j]);
		}
		newGridData.push(row);
	}
	return newGridData;
};
